import React from "react";
import { useQuery } from "react-query";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./PostImages.css";
import { fetchImages as fetchImagesWithFallback } from "../ImagesIncludes";
import PostImages from "./PostImages";

function AsyncPostImages(props) {

	function fetchImages() {
		return fetchImagesWithFallback(props.companyId, props.postTypeId, props.postId);
	}

	const { isLoading, data } = useQuery(
		["Documents", "DocumentOfPostAndType", props.postId, 3],
		() => fetchImages(props.companyId, props.postTypeId, props.postId),
		{
			enabled: (props.postId ? true : false),
			retry: 0
		}
	);

	if (isLoading)
		return (
			<div className="PostImages loading">
				<div className="w-100 mb-4" style={{ "height": "30vh" }}></div>
			</div>
		);

	if (!data) {
		if (props.forceImage === true)
			return (<div className="PostImages p-4" />);
		else
			return (false);
	}

	return (
		<PostImages
			{...props}
			images={data}
			async={false}
		/>
	);
}

export default AsyncPostImages;
